import Vue from "vue";

Vue.component("user-emails", {
	props: ["output", "label", "errorMessage"],
	data() {
		return {
			options: [],
			items: [],
			placeholder: window.labels.selectEmails,
			noItemMessage: window.labels.thereAreNoItems,
			timeoutId: ''
		};
	},
	computed: {
		computedValue: {
			get() {
				const text = this.output;
				if (!text) return [];
				return this.output.split(",");
			},
			set(value) {
				if (value && value.length > 0) {
					this.$emit("update:output", value[0].value);
				} else {
					this.$emit("update:output", '');
				}
			}
		}
	},
	mounted() {
		this.getUserEmailsForDropdown();
	},
	methods: {
		getUserEmailsForDropdown: function() {
			this.$services.nepUsers.getUserEmailsForDropdown({
			})
				.then((data) => {
					this.items = data.items;
					this.options = data.items;
					if (!this.options || this.options.length <= 0) {
						this.noItemMessage = htmlEntity.decode(window.labels.thereAreNoItems);
					}
				});
		},
		getFilteredItems(text) {			
			this.options = this.items.filter((option) => {
				return !this.computedValue.includes(option) && option.text.toLowerCase().indexOf(text.toLowerCase()) >=	0;
			});
		},
	},
	template: `
		<b-field :label="label | decodeHTMLEntity" :type="errorMessage ? 'is-danger' : ''" :message="errorMessage">
			<b-taginput class="input max-tag-one" :has-counter="false" v-model="computedValue" :data="options" autocomplete ref="taginput" maxtags="1" icon="label" open-on-focus @typing="getFilteredItems">
				<template #empty>{{ noItemMessage }}</template>
              	<template v-slot="props"> {{props.option.text}} </template>
			</b-taginput>
		</b-field>
	`
});